import { Button } from '../ui/button';
import { Heart, MessageCircle, Share2 } from 'lucide-react';

export const PostActions = ({ liked, likesCount, commentsCount, onLike, onToggleComments, onShare }) => (
  <div className="px-4 py-3 border-t border-border flex items-center gap-1">
    <Button
      variant="ghost"
      size="sm"
      onClick={onLike}
      className={`${liked ? 'text-red-400' : 'text-muted-foreground'} hover:text-red-400`}
      data-testid="like-post-btn"
    >
      <Heart className={`h-4 w-4 mr-1 ${liked ? 'fill-current' : ''}`} />
      {likesCount > 0 ? likesCount : '💪🏽'}
    </Button>

    <Button
      variant="ghost"
      size="sm"
      onClick={onToggleComments}
      className="text-muted-foreground hover:text-primary"
      data-testid="toggle-comments-btn"
    >
      <MessageCircle className="h-4 w-4 mr-1" />
      {commentsCount}
    </Button>

    <div className="relative group">
      <Button
        variant="ghost"
        size="sm"
        className="text-muted-foreground hover:text-primary"
        onClick={() => (typeof navigator !== 'undefined' && navigator.share ? onShare('native') : onShare('copy'))}
        data-testid="share-post-btn"
      >
        <Share2 className="h-4 w-4 mr-1" />
        Share
      </Button>
      <div className="absolute bottom-full left-0 mb-2 hidden group-hover:flex flex-wrap gap-1 bg-card border border-border p-2 rounded shadow-lg z-10 min-w-[180px]">
        {typeof navigator !== 'undefined' && navigator.share && (
          <Button size="sm" variant="default" onClick={() => onShare('native')} className="bg-primary text-black w-full mb-1">
            <Share2 className="h-3 w-3 mr-1" /> Share
          </Button>
        )}
        <Button size="sm" variant="ghost" onClick={() => onShare('copy')} className="w-full">
          Copy Link
        </Button>
      </div>
    </div>
  </div>
);
